export default [
  {
    path: '/purchase/list',
    name: 'purchase-list',
    meta: {
      name: '采购订单',
      keepAlive: true,
    },
    component: () => import(/* webpackChunkName: "purchase" */'@/views/purchase/list/index.vue')
  },
  {
    path: '/purchase/detail/:id',
    name: 'purchase-detail',
    meta: {
      name: '采购订单详情',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "purchase" */'@/views/purchase/orderDetail/index.vue')
  },
  {
    path: '/purchase/add',
    name: 'purchase-add',
    meta: {
      name: '新增采购订单',
      backName: 'purchase-list',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "purchase" */'@/views/purchase/addOrEdit/index.vue')
  },
  {
    path: '/purchase/edit/:id',
    name: 'purchase-edit',
    meta: {
      name: '编辑采购订单',
      backName: 'purchase-list',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "purchase" */'@/views/purchase/addOrEdit/index.vue')
  },
]
